__turbopack_context__.v({
  "actionButton": "features-module-scss-module__PK4ZAG__actionButton",
  "feature": "features-module-scss-module__PK4ZAG__feature",
  "featureHead": "features-module-scss-module__PK4ZAG__featureHead",
  "featureIcon": "features-module-scss-module__PK4ZAG__featureIcon",
  "featureText": "features-module-scss-module__PK4ZAG__featureText",
  "sectionWrapper": "features-module-scss-module__PK4ZAG__sectionWrapper",
  "textBlock": "features-module-scss-module__PK4ZAG__textBlock",
});
